import { twMerge } from "tailwind-merge";

const SIZES = {
  xs: 16,
  sm: 20,
  md: 30,
  lg: 40,
} as const;

interface SpinnerProps {
  readonly size?: "xs" | "sm" | "md" | "lg";
  readonly label?: string;
  readonly className?: string;
  readonly color?: "white" | "primary" | "current";
}

function RingSpinner({
  size,
  color,
}: {
  readonly size: number;
  readonly color: "white" | "primary" | "current";
}) {
  const trackColor =
    color === "white"
      ? "rgba(255, 255, 255, 0.5)"
      : color === "current"
        ? "currentColor"
        : undefined;
  const arcColor =
    color === "white"
      ? "white"
      : color === "current"
        ? "currentColor"
        : undefined;

  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className="animate-spin"
      style={color === "current" ? { opacity: 1 } : undefined}
    >
      <circle
        cx="15.8798"
        cy="15.8803"
        r="9.54816"
        stroke={trackColor ?? "var(--color-primary)"}
        strokeOpacity={color === "current" ? 0.4 : trackColor ? undefined : 0.5}
        strokeWidth="1.6"
      />
      <path
        d="M24.6938 10.7963C25.4732 10.3463 25.7485 9.34094 25.1955 8.63089C24.2458 7.41145 23.0623 6.38613 21.7087 5.61817C19.8809 4.58112 17.8093 4.051 15.7081 4.08259C13.6068 4.11419 11.5521 4.70634 9.75625 5.79787C8.42641 6.60618 7.27428 7.66661 6.36163 8.91406C5.83022 9.64041 6.13566 10.6371 6.92825 11.0634C7.72084 11.4898 8.69825 11.1797 9.26718 10.4824C9.8787 9.73282 10.6157 9.08947 11.4491 8.58292C12.7489 7.79286 14.2361 7.36424 15.7571 7.34138C17.278 7.31851 18.7774 7.70222 20.1004 8.45285C20.9487 8.93411 21.7046 9.55502 22.3384 10.2859C22.9281 10.9658 23.9143 11.2463 24.6938 10.7963Z"
        fill={arcColor ?? "var(--color-primary)"}
      />
    </svg>
  );
}

export default function Spinner({
  size = "md",
  label,
  className,
  color = "primary",
}: SpinnerProps) {
  const pixelSize = SIZES[size];

  return (
    <output
      aria-label={label ?? "Loading"}
      className={twMerge(
        "flex flex-col items-center justify-center",
        className,
      )}
    >
      <RingSpinner size={pixelSize} color={color} />
      {label && <span className="text-text-secondary mt-2">{label}</span>}
    </output>
  );
}
